import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import { TProvideInsuranceSchema, IProvideInsuranceContact } from './ProvideInsuranceSchema'

export const getErrorMessage = <T extends FieldErrors<TProvideInsuranceSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}

export interface IDocument {
  file: string
  fileFileName: string
}

export const parseData = (data: TProvideInsuranceSchema) => {
  const {
    email,
    fullName,
    phoneNumber,
    insuranceDocuments = [],
    motorCarrierId,
    organizationName,
  } = data || {}

  const formattedinsuranceDocuments = insuranceDocuments?.map(
    ({ file, fileFileName }: IDocument) => {
      return {
        file,
        fileFileName,
      }
    }
  )

  const formattedContactData = {
    motorCarrierId,
    email,
    fullName,
    insuranceDocuments: formattedinsuranceDocuments,
    phoneNumber,
    organizationName,
  }

  return formattedContactData
}

export const parseArrayData = (data: IProvideInsuranceContact[]) => {
  const formattedData = data.map(
    ({ email, fullName, insuranceDocuments, motorCarrierId, organizationName, phoneNumber }) => {
      return {
        motorCarrierId,
        email,
        fullName,
        insuranceDocuments,
        phoneNumber,
        organizationName,
      }
    }
  )
  return formattedData
}
